export interface SellingCompanyReport {
  key: string;
  name: string;
  tel: string;
  fax: string;
  email: string;
  web: string;
  vatRegNo: string;
  companyRegNo: string;
  address: string;
  multiLineAddress: string;
  multiLineAddressHTML: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  townCity: string;
  region: string;
  postCode: string;
  country: string;
  eoriNo: string;
  logoPath: string;
}
